import { NormalizedEntityItem } from '@/lib/edlink-utils';
import { DeltaKind } from '@airreading/common/data';
import { ExpandableSummarySection } from './expandable-summary-section';

type DeltaKindConfigProps = {
  color: string;
  label: (isDryRun: boolean) => string;
};

const DELTA_KIND_CONFIG: Record<DeltaKind, DeltaKindConfigProps> = {
  create: {
    color: 'border-l-green-500',
    label: (isDryRun) => (isDryRun ? 'Creations' : 'Created items'),
  },
  update: {
    color: 'border-l-blue-500',
    label: (isDryRun) => (isDryRun ? 'Updates' : 'Updated items'),
  },
  delete: {
    color: 'border-l-red-500',
    label: (isDryRun) => (isDryRun ? 'Deletions' : 'Deleted items'),
  },
};

interface DeltaKindGroupProps {
  kind: DeltaKind;
  items: NormalizedEntityItem[];
  isDryRun: boolean;
}

export function DeltaKindGroup({ kind, items, isDryRun }: DeltaKindGroupProps) {
  const { color, label } = DELTA_KIND_CONFIG[kind];

  return <ExpandableSummarySection label={label(isDryRun)} color={color} items={items} />;
}
